import { render } from "./hotline.vue?vue&type=template&id=22810f32&bindings={}"
import script from "./hotline.vue?vue&type=script&lang=js"
export * from "./hotline.vue?vue&type=script&lang=js"

import "./hotline.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script